import { render, staticRenderFns } from "./HeraConfirmLeave.vue?vue&type=template&id=1a2480b6&"
import script from "./HeraConfirmLeave.vue?vue&type=script&lang=js&"
export * from "./HeraConfirmLeave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports